var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22H12.4875V14.7594C12.4875 12.8509 12.8438 11.0014 15.181 11.0014C17.4812 11.0014 17.5131 13.1846 17.5131 14.8834V22H22V13.9717C22 10.0294 21.162 7 16.6168 7C14.4301 7 12.9655 8.21238 12.3652 9.36437H12.3068V7.36174H8V22ZM2.50151 0C3.8814 0 5 1.12001 5 2.49789C5 3.87818 3.8814 5 2.50151 5C1.118 5 0 3.87818 0 2.49789C0 1.12001 1.118 0 2.50151 0ZM0 22H5V7H0V22Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7d4e77074d9606138eb9cecc8b7bf39d.svg";
export { ForwardRef as ReactComponent };